import React from 'react';
import Head from 'next/head';
import { GTM_ID } from '@constants';

export const TechnicalHead = ({ title = '', isHidePage = false, meta = null }) => (
  <Head>
    <title>{title}</title>
    <link rel="shortcut icon" type="image/x-icon" href="favicon.ico" />
    <link rel="icon" type="image/svg+xml" href="/static/favicons/favicon.svg" />
    <link rel="apple-touch-icon-precomposed" sizes="16x16" href="/static/favicons/favicon-16x16.png" />
    <link rel="apple-touch-icon-precomposed" sizes="32x32" href="/static/favicons/favicon-32x32.png" />
    <link rel="apple-touch-icon-precomposed" sizes="48x48" href="/static/favicons/favicon-48x48.png" />
    <link rel="apple-touch-icon-precomposed" sizes="57x57" href="/static/favicons/favicon-57x57.png" />
    <link rel="apple-touch-icon-precomposed" sizes="76x76" href="/static/favicons/favicon-76x76.png" />
    <link rel="apple-touch-icon-precomposed" sizes="96x96" href="/static/favicons/favicon-96x96.png" />
    <link rel="apple-touch-icon-precomposed" sizes="120x120" href="/static/favicons/favicon-120x120.png" />
    <link rel="apple-touch-icon-precomposed" sizes="144x144" href="/static/favicons/favicon-144x144.png" />
    <link rel="apple-touch-icon-precomposed" sizes="180x180" href="/static/favicons/favicon-180x180.png" />
    <link rel="icon" sizes="192x192" href="/static/favicons/favicon-192x192.png" />
    <link rel="apple-touch-icon-precomposed" sizes="512x512" href="/static/favicons/favicon-512x512.png" />
    <link href="/styles.css" rel="stylesheet" />
    <script
      type="text/javascript"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){
              w[l]=w[l]||[];
              w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
              })(window,document,'script','dataLayer', '${GTM_ID}');`,
      }}
    />
    <meta charSet="UTF-8" />
    <meta name="Author" content="Kelnik" />
    {isHidePage && '<meta name="robots" content="noindex, nofollow" />'}
    {meta && meta()}
  </Head>
);
